import { ActionIcon, Tooltip } from '@mantine/core';
import { useMantineColorScheme, useComputedColorScheme } from '@mantine/core';
import { Sun, Moon } from '@phosphor-icons/react';

interface ThemeToggleProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'subtle' | 'default' | 'filled' | 'light' | 'outline';
}

export function ThemeToggle({ size = 'md', variant = 'subtle' }: ThemeToggleProps) {
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('dark', { getInitialValueInEffect: true });
  const isDark = computedColorScheme === 'dark';

  const toggle = () => {
    setColorScheme(isDark ? 'light' : 'dark');
  };

  return (
    <Tooltip label={isDark ? 'Switch to light mode' : 'Switch to dark mode'} openDelay={300} withArrow>
      <ActionIcon
        variant={variant}
        size={size}
        onClick={toggle}
        aria-label="Toggle theme color scheme"
        style={{
          color: 'var(--text-secondary)',
          transition: 'transform 150ms ease, color 150ms ease, background-color 150ms ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = 'var(--text-primary)';
          e.currentTarget.style.backgroundColor = 'var(--surface-hi)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = 'var(--text-secondary)';
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        {isDark ? (
          <Sun size={18} weight="duotone" color="var(--amber)" />
        ) : (
          <Moon size={18} weight="duotone" color="var(--text-primary)" />
        )}
      </ActionIcon>
    </Tooltip>
  );
}
